import { useState, useEffect } from 'react'

export const useSessionStorage = (keyname, defaultValue) => {
    
    const [currentStep, setCurrentStep] = useState(() => {
        let value;
        try {
            value = JSON.parse(
                window.sessionStorage.getItem(keyname) || defaultValue
            )
        } catch (e) {
            value = defaultValue
        }
        return value
    });

	useEffect(
		() => window.sessionStorage.setItem(keyname, JSON.stringify(currentStep)), [currentStep, keyname]
		);

    return [currentStep, setCurrentStep]
    
}
